import React, { ChangeEvent, FunctionComponent } from "react";

import { Caption, ColSpan, GridColumnCount, GridGapSize, GridLayout, GridLayoutItem } from "@multiweb/reactComponents";
import { LOC_BASIC_CONDITION, LOC_COMMENT, LOC_DAY, LOC_HOUR, LOC_INCREMENT_TYPE, LOC_MINUTE, LOC_MONTH, LOC_NUMBER, LOC_SECOND, LOC_STEP_CHANGE, LOC_VALUE, LOC_WEEK, LOC_YEAR } from "../../../../../../locKeys";
import { DateTimePrecision } from "../../../../../../workflowModel/Actions";
import { CONST_ACTION_COMMENT_AT, CONST_ACTION_CONDITION_AT, CONST_INCREMENT_DATE_TIME_PRECISION_AT, CONST_INCREMENT_DATE_TIME_VALUE_AT, CONST_INCREMENT_NUMBER_ATTR_NAME_AT } from "../../../../../../workflowParser/constants";
import { Edit, Memo, WfOption, WfSelect } from "../../../../components";
import { MAX_INPUT_LENGTH_S, MAX_INPUT_LENGTH_XS } from "../constants";
import { ActionPageProps } from "../types";

export const IncrementValuePage: FunctionComponent<ActionPageProps> = ({ properties, updateAction, hostKey }) => {
    const onAttrNameChange = (e: ChangeEvent<HTMLInputElement>) => {
        updateAction([{ key: CONST_INCREMENT_NUMBER_ATTR_NAME_AT, value: e.target.value }]);
    };

    const onValueChange = (e: ChangeEvent<HTMLInputElement>) => {
        updateAction([{ key: CONST_INCREMENT_DATE_TIME_VALUE_AT, value: e.target.value }]);
    };

    const onValueTypeChange = (e: ChangeEvent<HTMLSelectElement>) => {
        updateAction([{ key: CONST_INCREMENT_DATE_TIME_PRECISION_AT, value: e.target.value }]);
    };

    const onConditionChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        updateAction([{ key: CONST_ACTION_CONDITION_AT, value: e.target.value }]);
    };

    const onCommentChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
        updateAction([{ key: CONST_ACTION_COMMENT_AT, value: e.target.value }]);
    };

    return (
        <GridLayout columns={GridColumnCount.three} gap={GridGapSize.two}>
            <GridLayoutItem colSpan={ColSpan.three}>
                <Caption required locKey={LOC_VALUE} />
                <Edit qa={LOC_VALUE} required maxLength={MAX_INPUT_LENGTH_S} value={properties[CONST_INCREMENT_NUMBER_ATTR_NAME_AT]} onChange={onAttrNameChange} {...{ hostKey }} />
            </GridLayoutItem>
            <GridLayoutItem colSpan={ColSpan.one}>
                <Caption locKey={LOC_INCREMENT_TYPE} />
                <WfSelect qa={LOC_INCREMENT_TYPE} value={properties[CONST_INCREMENT_DATE_TIME_PRECISION_AT]} onChange={onValueTypeChange} {...{ hostKey }}>
                    <WfOption qa={DateTimePrecision.number} value={DateTimePrecision.number} locKey={LOC_NUMBER} />
                    <WfOption qa={DateTimePrecision.second} value={DateTimePrecision.second} locKey={LOC_SECOND} />
                    <WfOption qa={DateTimePrecision.minute} value={DateTimePrecision.minute} locKey={LOC_MINUTE} />
                    <WfOption qa={DateTimePrecision.hour} value={DateTimePrecision.hour} locKey={LOC_HOUR} />
                    <WfOption qa={DateTimePrecision.day} value={DateTimePrecision.day} locKey={LOC_DAY} />
                    <WfOption qa={DateTimePrecision.week} value={DateTimePrecision.week} locKey={LOC_WEEK} />
                    <WfOption qa={DateTimePrecision.month} value={DateTimePrecision.month} locKey={LOC_MONTH} />
                    <WfOption qa={DateTimePrecision.year} value={DateTimePrecision.year} locKey={LOC_YEAR} />
                </WfSelect>
            </GridLayoutItem>
            <GridLayoutItem colSpan={ColSpan.two}>
                <Caption locKey={LOC_STEP_CHANGE} />
                <Edit qa={LOC_STEP_CHANGE} type={"number"} maxLength={MAX_INPUT_LENGTH_XS} value={properties[CONST_INCREMENT_DATE_TIME_VALUE_AT] || "1"} onChange={onValueChange} {...{ hostKey }}/>
            </GridLayoutItem>
            <GridLayoutItem colSpan={ColSpan.three}>
                <Caption locKey={LOC_BASIC_CONDITION} />
                <Memo qa={LOC_BASIC_CONDITION} value={properties[CONST_ACTION_CONDITION_AT]} onChange={onConditionChange} {...{ hostKey }} />
            </GridLayoutItem>
            <GridLayoutItem colSpan={ColSpan.three}>
                <Caption locKey={LOC_COMMENT} />
                <Memo qa={LOC_COMMENT} value={properties[CONST_ACTION_COMMENT_AT]} onChange={onCommentChange} {...{ hostKey }} />
            </GridLayoutItem>
        </GridLayout>
    );
};
